// ============================================================================ ini modal untuk Video!! ===============================================================================

import { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import '../style/PopupModal.css'; 
import promoVideo from '../assets/images/feevid.mp4'; 

const PopupModal = () => {
    const [show, setShow] = useState(false);

    useEffect(() => {
        const hasBeenShown = sessionStorage.getItem('popupShown');

        if (!hasBeenShown) {
            const timer = setTimeout(() => {
                setShow(true);
                sessionStorage.setItem('popupShown', 'true');
            }, 2000);

            return () => clearTimeout(timer);
        }
    }, []);

    const handleClose = () => setShow(false);

    return (
        <Modal show={show} onHide={handleClose} centered size="lg" className="popup-modal">
            <Modal.Header closeButton>
                {/* nambahkan judul di sini jika perlu */}
            </Modal.Header>
            <Modal.Body>
                {/* Komponen Image diganti dengan tag <video> */}
                <video 
                    src={promoVideo}
                    autoPlay  // Memutar video secara otomatis
                    muted     // Wajib agar autoplay berfungsi di banyak browser
                    loop      // Mengulang video
                    playsInline // Mencegah video menjadi fullscreen di HP
                    className="promo-image" // Menggunakan kelas CSS yang sama dengan gambar
                />
                <div className="promo-text">
                    <h3>Lelang Spesial Akhir Tahun!</h3>
                    <p>Jangan lewatkan koleksi numismatik langka dari seluruh Nusantara. Lelang dimulai 25 Desember!</p>
                    <Button variant="warning" href="https://bid.syailendra-auction.com/" target="_blank">
                        Lihat Katalog Sekarang
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default PopupModal;

// ============================================================================ ini modal untuk gambar!! ===============================================================================

// import { useState, useEffect } from 'react';
// import { Modal, Button, Image } from 'react-bootstrap';
// import '../style/PopupModal.css'; 

// // 1. Ganti path ini agar sesuai dengan lokasi dan nama file foto iklan Anda
// import promoImage from '../assets/images/promo-image.jpg'; 

// const PopupModal = () => {
//     const [show, setShow] = useState(false);

//     useEffect(() => {
//         // Mengecek apakah pop-up sudah pernah muncul di sesi ini
//         const hasBeenShown = sessionStorage.getItem('popupShown');

//         if (!hasBeenShown) {
//             // Memberikan jeda 2 detik sebelum pop-up muncul
//             const timer = setTimeout(() => {
//                 setShow(true);
//                 sessionStorage.setItem('popupShown', 'true');
//             }, 2000);

//             return () => clearTimeout(timer);
//         }
//     }, []);

//     const handleClose = () => setShow(false);

//     return (
//         <Modal show={show} onHide={handleClose} centered size="lg" className="popup-modal">
//             <Modal.Header closeButton>
//                 {/* Header kosong untuk tombol close saja */}
//             </Modal.Header>
//             <Modal.Body>
//                 {/* 2. Menggunakan komponen Image untuk menampilkan foto */}
//                 <Image 
//                     src={promoImage} 
//                     fluid 
//                     className="promo-image" 
//                     alt="Promo Syailendra Auction"
//                 />
                
//                 <div className="promo-text">
//                     <h3>Happy Holiday!</h3>
//                     <p>Sampai kita bertemu kembali di Syailendra Auction #19. Lelang dimulai 29 Desember dan live lelang di mulai 7 Januari!</p>
//                     <Button variant="warning" href="https://bid.syailendra-auction.com/" target="_blank">
//                         Lihat Katalog Sekarang
//                     </Button>
//                 </div>
//             </Modal.Body>
//         </Modal>
//     );
// }

// export default PopupModal;
